import React from 'react';
import { useAuth } from '../../context/AuthContext';
import NavigationMenu from '../Sidebar/Sidebar';
import MobileNav from '../MobileNav';
import './AppHeader.css';

function AppHeader({ subscriptionStatus }) {
  const { user, logout } = useAuth();

  if (!user) return <div className="app-header" style={{visibility: 'hidden'}}></div>;

  return (
    <header className="app-header">
      <div className="app-header-left">
        <img
          src="https://customer-assets.emergentagent.com/job_f48ed865-f137-40ec-8ec5-750617ca0014/artifacts/jm5y5oub_logo.png"
          alt="ZENTA Logo"
          className="app-header-logo"
        />
      </div>
      <div className="app-header-right">
        {/* Navigation Menu - Works for both Mobile and Desktop */}
        <NavigationMenu
          user={user}
          subscriptionStatus={subscriptionStatus}
          onLogout={logout}
        />
      </div>
    </header>
  );
}

export default AppHeader;
